import React, { useState } from "react";
import { Link } from "react-router-dom";

const Navbar = () => {
  const menuItems = [
    { name: "Home", link: "/" },
    { name: "Register", link: "/registeruser" },
    { name: "Jal Booking", link: "/createbooking" },
    { name: "My Bookings", link: "/mybookings" },
    {
      name: "Login",
      submenu: [
        { name: "Admin login", link: "/adminlogin" },
        { name: "Forgot Password", link: "/forgotpassword" },
      ],
    },
    {
      name: "OCRWS PH-1",
      link: "https://omaxecityresidents.co.in/",
      image: "Images/Omaxe.webp", // ✅ Path to your logo
    },
  ];

  const [activeMenu, setActiveMenu] = useState(null);

  const selectedNavbarMenuItem = (index) => setActiveMenu(index);
  const handleMouseLeave = () => setActiveMenu(null);

  return (
    <ul className="navbar-items" id="navbar-menu">
      {menuItems.map((item, index) => (
        <li
          key={item.name}
          className="navbar-items-li"
          onMouseEnter={() => item.submenu && selectedNavbarMenuItem(index)}
          onMouseLeave={() => item.submenu && handleMouseLeave()}
        >
          {/* ✅ If item has an image, render it differently */}
          {item.image ? (
            <a
              href={item.link}
              target="_blank"
              rel="noopener noreferrer"
              className="navbar-items-link logo-link"
            >
              <img
                src={item.image}
                alt={item.name}
                className="navbar-logo"
              />
            </a>
          ) : item.submenu ? (
            <span className="navbar-items-link no-link">{item.name} ▾</span>
          ) : (
            <Link to={item.link || "#"} className="navbar-items-link">
              {item.name}
            </Link>
          )}

          {/* ✅ Submenu */}
          {item.submenu && activeMenu === index && (
            <ul className="submenuContainer">
              {item.submenu.map((subItem) => (
                <li key={subItem.name} className="submenu-li">
                  <Link to={subItem.link} className="submenu-link">
                    {subItem.name}
                  </Link>
                </li>
              ))}
            </ul>
          )}
        </li>
      ))}
    </ul>
  );
};

export default Navbar;
